// extracted by mini-css-extract-plugin
export default {"titleView":"forgot-password_titleView__yOfy3","elements":"forgot-password_elements__Op9TW"};